import { Component, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { DocumentVerificationListService } from '@app/_services/document-verification-list.service';
import { first } from 'rxjs/operators';
import { DocumentVerificationList } from '@app/_models/DocumentVerificationList';
import { Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { NgxSpinnerService } from "ngx-spinner";
import { statusRemark } from '@app/_models/statusRemark';

@Component({
  selector: 'app-document-verification-list',
  templateUrl: './document-verification-list.component.html',
  styleUrls: ['./document-verification-list.component.css']
})

export class DocumentVerificationListComponent implements OnInit {

  imgID = "Angular";

  dtTrigger: Subject<any> = new Subject<any>();
  isVrPdf: boolean = false;
  isVrImage: boolean = false;
  isUPdf: boolean = false;
  isUImage: boolean = false;
  request: DocumentVerificationList[];
  editProfileForm: FormGroup;
  title = 'docVerification';
  dtOptions: DataTables.Settings = {};
  display = "none";
  getId: number;
  upload_doc_path: any = "/University/assets/images/No-results-found.jpg";
  originalDocUploadFilePath: any = "/University/assets/images/No-results-found.jpg";
  userId = localStorage.getItem('user_id');
  returnUrl
  reasonVal: string;
  cgpiVal: string;
  statusRemark = new statusRemark();
  RemarkForm: FormGroup;
  CGPIForm: FormGroup;
  submitted = false;
  submitted1 = false;
  submitted3 = false;
  submitted4 = false;
  fileURL;
  fileURL1;
  src;
  src1;
  getImage = false;
  isImageR = false;
  isImageL = false;
  OnlyRemarkForm: FormGroup;
  EditReasonForm: FormGroup;
  editReasonVal: string;
  onlyRemarkVal: string;
  // constVal = 0
  // constValOriginal = 0
  noImage1 = false;
  noImage2 = false;
  imgname = "uploadImg1"
  imgname2 = "uploadImg2"
  rejectionTrail

  @ViewChild('showRejectionTrailBox', { read: TemplateRef}) showRejectionTrailBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('viewModal', { read: TemplateRef }) viewModalTemplate: TemplateRef<any>;
  @ViewChild('closebutton') closebutton;
  @ViewChild('closebuttonRemark') closebuttonRemark;
  @ViewChild('showModalBoxImage', { read: TemplateRef }) showModalBoxImage: TemplateRef<any>;
  @ViewChild('showModalBoxTEstingMagnify', { read: TemplateRef }) showModalBoxTEstingMagnify: TemplateRef<any>;

  constructor(
    private documentVerificationListService: DocumentVerificationListService,
    config: NgbModalConfig, private elRef: ElementRef,
    private modalService: NgbModal,
    private router: Router,
    private SpinnerService: NgxSpinnerService,
    private formBuilder: FormBuilder
  ) { }
  get f() { return this.RemarkForm.controls; }
  get g() { return this.CGPIForm.controls; }
  get h() { return this.OnlyRemarkForm.controls; }
  get i() { return this.EditReasonForm.controls; }
  showFlag: boolean = false;
  selectedImageIndex: number = -1;
  currentIndex
  imageObject: Array<object> = [];
  showLightbox(index) {
    this.selectedImageIndex = index;
    this.showFlag = true;
    this.imageObject = [
      {
        image: this.upload_doc_path,
        alt: 'alt of image', // Optional
        title: 'To be verified' // Optional: Show image with description text 
      },
      {
        image: this.originalDocUploadFilePath, // Support base64 image
        title: 'System document', //Optional: You can use this key if want to show image with title
        alt: 'Image alt' //Optional: You can use this key if want to show image with alt
      }
    ];
  }

  closeEventHandler() {
    this.showFlag = false;
    this.currentIndex = -1;
  }


  ngOnInit(): void {
    // this.magnify('uploadImg1', 3);
    this.EditReasonForm = this.formBuilder.group({
      editReasonVal: ['', Validators.required]
    })
    this.OnlyRemarkForm = this.formBuilder.group({

      onlyRemarkVal: ['', Validators.required]
    });
    this.RemarkForm = this.formBuilder.group({

      cgpiVal: ['', Validators.required],
      reasonVal: ['', Validators.required]
    });

    this.CGPIForm = this.formBuilder.group({

      cgpiVal: ['', Validators.required]
    });

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };

    this.documentVerificationListService.getDocumentVerificationList()
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.request = data.respData;
          console.log(this.request)
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }

  fetchEditReason(nm){
    console.log("------------");
    this.editReasonVal = '';
    this.statusRemark.id = this.getId;
    this.statusRemark.status = nm.target.name;
    this.statusRemark.verifiedby = this.userId;
  }

  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, '');
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  openPdf() {
    window.open(this.fileURL);
  }

  openPdf1() {
    window.open(this.fileURL1);
  }

  openModal1(id) {

    this.modalService.open(this.showModalBoxTEstingMagnify, { size: 'xl', centered: true });
    //this.magnify('uploadImg1', 3);
  }

  fetchRejectionTrail(){
    console.log("-----Rejection Trail------", this.getId)
    this.modalService.open(this.showRejectionTrailBoxTemplate, { windowClass: 'my-class', size: 'sm', centered: true });
    this.documentVerificationListService.getRejectionReason(this.getId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.rejectionTrail = data.respData;
          console.log(this.rejectionTrail)
          // this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }

  openModal(id) {
    this.getId = id;
    this.isVrImage = false;
    this.isVrPdf = false;

    this.isImageR = false;
    this.isImageL = false;

    this.upload_doc_path = '';
    this.originalDocUploadFilePath = '';
    this.documentVerificationListService.getverifydocument(id)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          console.log(environment.apiUrl + data.respData[0].upload_doc_path)
          this.documentVerificationListService.getverifydocumentImage(`${environment.apiUrl}` + data.respData[0].upload_doc_path).pipe(first())
            .subscribe(
              add => {
                console.log("addadd---", add, add.type)
                let reader = new FileReader();
                if (add.type == "application/pdf") {
                  this.isVrPdf = true;
                  this.isVrImage = false;
                  reader.addEventListener("load", () => {
                    this.upload_doc_path = reader.result;
                    var base64Array = this.upload_doc_path.substring(28);
                    console.log("=====base64Array===========", base64Array);
                    this.src = this._base64ToArrayBuffer(base64Array);
                    let file = new Blob([add], { type: 'application/pdf' });
                    this.fileURL = URL.createObjectURL(file);
                    // this.magnify('uploadImg1', 3);
                  }, false);
                } else {
                  this.isVrImage = true;
                  this.isVrPdf = false;
                  reader.addEventListener("load", () => {
                    this.upload_doc_path = reader.result;
                    this.noImage1 = false;
                    console.log(reader.result);
                    // this.magnify('uploadImg1', 3);
                  }, false);
                }

                console.log(this.isVrImage, this.isVrPdf,)
                if (add) {
                  reader.readAsDataURL(add);

                }
                this.isImageL = true;
                if (this.isVrPdf == true) {
                  var al = window.open('', 'OPEN');
                  window.setTimeout(function () { al.close() }, 100);
                }
                console.log("=======img===========L======", this.isImageR, this.isImageL);
                if (this.isImageL == true && this.isImageR == true) {
                  this.SpinnerService.hide();
                  // this.constVal = 0
                  // this.constValOriginal = 0
                  // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });

                  this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
                }
              }, error => {
                this.SpinnerService.hide();
                // this.constVal = 0
                // this.constValOriginal = 0
                // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });
                this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
                this.upload_doc_path = "/University/assets/images/No-results-found.jpg"; // test server
                this.noImage1 = true;
                console.log(error)
              })
          if (data.respData[0].originalDocUploadFilePath != undefined) {
            this.documentVerificationListService.getverifydocumentImage(`${environment.apiUrl}` + data.respData[0].originalDocUploadFilePath).pipe(first())
              .subscribe(
                data2 => {
                  console.log("data2---", data2, data2.type)
                  let reader = new FileReader();
                  if (data2.type == "application/pdf") {
                    this.isUPdf = true;
                    this.isUImage = false;
                    reader.addEventListener("load", () => {
                      this.originalDocUploadFilePath = reader.result;
                      var base64Array = this.originalDocUploadFilePath.substring(28);
                      console.log("=====base64Array===========", base64Array);
                      this.src1 = this._base64ToArrayBuffer(base64Array);
                      let file = new Blob([data2], { type: 'application/pdf' });
                      this.fileURL1 = URL.createObjectURL(file);
                      // this.magnify('uploadImg2', 3);
                    }, false);
                  } else {
                    this.isUImage = true;
                    this.isUPdf = false;
                    reader.addEventListener("load", () => {
                      this.originalDocUploadFilePath = reader.result;
                      console.log(reader.result);
                      this.noImage2 = false;
                      // this.magnifyOriginal('uploadImg2', 3);
                    }, false);
                  }
                  console.log(this.isUImage, this.isUPdf, this.isVrImage, this.isVrPdf)
                  if (data2) {
                    reader.readAsDataURL(data2);
                    //this.magnify('uploadImg2', 3);
                  }
                  this.isImageR = true;
                  if (this.isUPdf == true) {
                    var al = window.open('', 'OPEN');
                    window.setTimeout(function () { al.close() }, 100);
                  }
                  console.log("=======img===========R======", this.isImageR, this.isImageL);
                  if (this.isImageL == true && this.isImageR == true) {
                    this.SpinnerService.hide();
                    // this.constVal = 0
                    // this.constValOriginal = 0
                    // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });
                    this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
                  }
                }),
              console.log(this.request)
          }
          else {
            this.isUPdf = false;
            this.isUImage = true;
            this.isImageR = true;
            this.originalDocUploadFilePath = "/University/assets/images/No-results-found.jpg";
            this.noImage2 = true;
          }
          if (this.isImageL == true && this.isImageR == true) {
            this.SpinnerService.hide();
            // this.constVal = 0
            // this.constValOriginal = 0
            // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });
            this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
            // this.magnify('uploadImg1', 3);this.magnify('uploadImg2', 3);
          }
        },
        error => {
          this.isUPdf = false;
          this.isUImage = true;
          this.isImageR = true;
          if (this.isImageL == true && this.isImageR == true) {
            this.SpinnerService.hide();
            // this.constVal = 0
            // this.constValOriginal = 0
            // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });
            this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class' });
          }
          this.originalDocUploadFilePath = "/University/assets/images/No-results-found.jpg"; // test server
          this.noImage2 = true;
          console.log(error)
        }
      )
    this.SpinnerService.show();
    // this.modalService.open(this.viewModalTemplate);

  }
  showmagnify() {
   // this.magnify('uploadImg1', 3);
  }
  showmagnifySystem() {
    // alert(this.originalDocUploadFilePath)

    //this.magnifyOriginal('uploadImg2', 3);
  }
  openRemarkModal(nm) {
    this.reasonVal = '';
    this.statusRemark.id = this.getId;
    this.statusRemark.status = nm.target.name;
    this.statusRemark.verifiedby = this.userId;
    //this.statusRemark.remark = 'ABCD';
  }

  openCgpiModal(nm) {
    this.cgpiVal = '';
    this.statusRemark.id = this.getId;
    this.statusRemark.status = nm.target.name;
    this.statusRemark.verifiedby = this.userId;
  }

  openOnlyRemarkModal(nm) {
    this.onlyRemarkVal = '';
    this.statusRemark.id = this.getId;
    this.statusRemark.status = nm.target.name;
    this.statusRemark.verifiedby = this.userId;
    // this.h.onlyRemarkVal
  }

  changeEditStatusWithReason(e){
    this.submitted4 = true;
    console.log("********",this.editReasonVal)
    this.statusRemark.editreason = this.editReasonVal;
    var id = this.getId;
    if(this.EditReasonForm.invalid){
      return;
    }
    this.SpinnerService.show();
    this.documentVerificationListService.setStatus(this.statusRemark)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.SpinnerService.hide();
          // alert("Status has been updated.")


          for (let i = 0; i < this.request.length; ++i) {
            if (this.request[i].id === id) {
              this.request.splice(i, 1);
            }
          }

          this.modalService.open(this.showModalBoxTemplate);
        },
        error => {
          console.log(error)
        }
      )
  }

  changeOnlyRemarkStatus(e) {

    this.submitted3 = true;
    console.log(e.target.file)
    console.log(this.onlyRemarkVal)
    this.statusRemark.remark = this.onlyRemarkVal;
    var id = this.getId;
    this.documentVerificationListService.setStatus(this.statusRemark)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.SpinnerService.hide();
          // alert("Status has been updated.")


          for (let i = 0; i < this.request.length; ++i) {
            if (this.request[i].id === id) {
              this.request.splice(i, 1);
            }
          }

          this.modalService.open(this.showModalBoxTemplate);
        },
        error => {
          console.log(error)
        }
      ),
      this.SpinnerService.show();

  }

  changeRemarkStatus(e) {
    this.submitted = true;
    this.statusRemark.remark = this.reasonVal;
    this.statusRemark.cgpi = this.cgpiVal;
    if (this.RemarkForm.invalid) {
      return;
    }
    var id = this.getId;
    this.statusRemark.remark = this.reasonVal;
    //alert(this.reasonVal)
    this.documentVerificationListService.setStatus(this.statusRemark)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.SpinnerService.hide();
          for (let i = 0; i < this.request.length; ++i) {
            if (this.request[i].id === id) {
              this.request.splice(i, 1);
            }
          }
          this.closebuttonRemark.nativeElement.click();
          this.modalService.open(this.showModalBoxTemplate);
        },
        error => {
          console.log(error)
        }
      ),
      this.SpinnerService.show();
  }

  changeStatus(e) {
    // alert('Approved');
    this.submitted1 = true;
    var id = this.getId;
    //  var status = "Approved"; var status = e.target.name;
    // this.statusRemark.remark = this.reasonVal;
    this.statusRemark.id = this.getId;
    // this.statusRemark.status = e.target.name;
    this.statusRemark.verifiedby = this.userId;
    this.statusRemark.cgpi = this.cgpiVal;
    console.log(id, this.cgpiVal)
    if (this.CGPIForm.invalid) {
      return;
    }

    this.documentVerificationListService.setStatus(this.statusRemark)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.SpinnerService.hide();
          // alert("Status has been updated.")


          for (let i = 0; i < this.request.length; ++i) {
            if (this.request[i].id === id) {
              this.request.splice(i, 1);
            }
          }

          this.modalService.open(this.showModalBoxTemplate);
        },
        error => {
          console.log(error)
        }
      ),
      this.SpinnerService.show();
  }
  refresh(): void {
    location.reload();
    // this.closebuttonRemark.nativeElement.click();
    // this.closebutton.nativeElement.click();
    // this.modalService.dismissAll(this.showModalBoxTemplate);
    // this.returnUrl = "verifier";
    // this.router.navigate([this.returnUrl]);
  }

  // magnifyOriginal(imgID, zoom) {
  //   //alert('hi')
  //   this.constValOriginal = this.constValOriginal + 1
  //   //alert( this.constValOriginal)
  //   var ourImage = imgID;//new Image();
  //   ourImage = imgID;
  //   var img, glass, w, h, bw;
  //   if (this.constValOriginal == 1) {
  //     img = document.getElementById(imgID);
  //     ourImage = img;
  //     //glass.removeAttribute('class', 'img-magnifier-glassoriginal');
  //     /*create magnifier glass:*/
  //     glass = document.createElement('DIV');
  //     glass.setAttribute('class', 'img-magnifier-glassoriginal');
  //     /*insert magnifier glass:*/

  //     ourImage.parentElement.insertBefore(glass, ourImage);
  //     /*set background properties for the magnifier glass:*/
  //     glass.style.backgroundImage = "url('" + this.originalDocUploadFilePath + "')";
  //     glass.style.backgroundRepeat = 'no-repeat';
  //     glass.style.backgroundSize =
  //       ourImage.width * zoom + 'px ' + ourImage.height * zoom + 'px';
  //     bw = 3;
  //     w = glass.offsetWidth / 2;
  //     h = glass.offsetHeight / 2;
  //     /*execute a function when someone moves the magnifier glass over the image:*/
  //     glass.addEventListener('mousemove', moveMagnifier);
  //     ourImage.addEventListener('mousemove', moveMagnifier);
  //     /*and also for touch screens:*/
  //     glass.addEventListener('touchmove', moveMagnifier);
  //     ourImage.addEventListener('touchmove', moveMagnifier);
  //     function moveMagnifier(e) {
  //       // alert('lllll')
  //       var pos, x, y;
  //       /*prevent any other actions that may occur when moving over the image*/
  //       e.preventDefault();
  //       /*get the cursor's x and y positions:*/
  //       pos = getCursorPos(e);
  //       x = pos.x;
  //       y = pos.y;
  //       /*prevent the magnifier glass from being positioned outside the image:*/
  //       if (x > ourImage.width - w / zoom) {
  //         x = ourImage.width - w / zoom;
  //       }
  //       if (x < w / zoom) {
  //         x = w / zoom;
  //       }
  //       if (y > ourImage.height - h / zoom) {
  //         y = ourImage.height - h / zoom;
  //       }
  //       if (y < h / zoom) {
  //         y = h / zoom;
  //       }
  //       /*set the position of the magnifier glass:*/
  //       glass.style.left = x - w + 'px';
  //       glass.style.top = y - h + 'px';
  //       /*display what the magnifier glass "sees":*/
  //       //console.log(x + '---' + y + '---' +zoom)
  //       glass.style.backgroundPosition =
  //         '-' + (x * zoom - w + bw) + 'px -' + (y * zoom - h + bw) + 'px';
  //     }
  //     function getCursorPos(e) {
  //       var a,
  //         x = 0,
  //         y = 0;
  //       e = e || window.event;
  //       /*get the x and y positions of the image:*/
  //       a = ourImage.getBoundingClientRect();
  //       /*calculate the cursor's x and y coordinates, relative to the image:*/
  //       x = e.pageX - a.left;
  //       y = e.pageY - a.top;
  //       /*consider any page scrolling:*/
  //       x = x - window.pageXOffset;
  //       y = y - window.pageYOffset;
  //       return { x: x, y: y };
  //     }

  //   }
  // }
  // magnify(imgID, zoom) {
  //   this.constVal = this.constVal + 1
  //   //alert('hi')
  //   var ourImage = imgID;//new Image();
  //   ourImage = imgID;
  //   var img, glass, w, h, bw;
  //   if (this.constVal == 1) {
  //     img = document.getElementById(imgID);
  //     ourImage = img;
  //     /*create magnifier glass:*/
  //     glass = document.createElement('DIV');
  //     glass.setAttribute('class', 'img-magnifier-glass');
  //     /*insert magnifier glass:*/
  //     ourImage.parentElement.insertBefore(glass, ourImage);
  //     /*set background properties for the magnifier glass:*/
  //     glass.style.backgroundImage = "url('" + this.upload_doc_path + "')";
  //     glass.style.backgroundRepeat = 'no-repeat';
  //     glass.style.backgroundSize =
  //       ourImage.width * zoom + 'px ' + ourImage.height * zoom + 'px';
  //     bw = 3;
  //     w = glass.offsetWidth / 2;
  //     h = glass.offsetHeight / 2;
  //     /*execute a function when someone moves the magnifier glass over the image:*/
  //     glass.addEventListener('mousemove', moveMagnifier);
  //     ourImage.addEventListener('mousemove', moveMagnifier);
  //     /*and also for touch screens:*/
  //     glass.addEventListener('touchmove', moveMagnifier);
  //     ourImage.addEventListener('touchmove', moveMagnifier);
  //     function moveMagnifier(e) {
  //       // alert('lllll')
  //       var pos, x, y;
  //       /*prevent any other actions that may occur when moving over the image*/
  //       e.preventDefault();
  //       /*get the cursor's x and y positions:*/
  //       pos = getCursorPos(e);
  //       x = pos.x;
  //       y = pos.y;
  //       /*prevent the magnifier glass from being positioned outside the image:*/
  //       if (x > ourImage.width - w / zoom) {
  //         x = ourImage.width - w / zoom;
  //       }
  //       if (x < w / zoom) {
  //         x = w / zoom;
  //       }
  //       if (y > ourImage.height - h / zoom) {
  //         y = ourImage.height - h / zoom;
  //       }
  //       if (y < h / zoom) {
  //         y = h / zoom;
  //       }
  //       /*set the position of the magnifier glass:*/
  //       glass.style.left = x - w + 'px';
  //       glass.style.top = y - h + 'px';
  //       /*display what the magnifier glass "sees":*/
  //       //console.log(x + '---' + y + '---' +zoom)
  //       glass.style.backgroundPosition =
  //         '-' + (x * zoom - w + bw) + 'px -' + (y * zoom - h + bw) + 'px';
  //     }
  //     function getCursorPos(e) {
  //       var a,
  //         x = 0,
  //         y = 0;
  //       e = e || window.event;
  //       /*get the x and y positions of the image:*/
  //       a = ourImage.getBoundingClientRect();
  //       /*calculate the cursor's x and y coordinates, relative to the image:*/
  //       x = e.pageX - a.left;
  //       y = e.pageY - a.top;
  //       /*consider any page scrolling:*/
  //       x = x - window.pageXOffset;
  //       y = y - window.pageYOffset;
  //       return { x: x, y: y };
  //     }
  //   }
  // }
}
